<script setup>
import { onMounted, ref } from "vue";
import axios from "axios";
import { useI18n } from "vue-i18n";
const { locale } = useI18n();
import { Link, usePage } from "@inertiajs/vue3";
import { helperStore } from "@/store/helper";
const helper = helperStore();
const page = usePage();
const company = page.props.shared_data.company;
const primaryPhone = company["phone"].split(",");

// const apps_banner = page.props.shared_data.apps_banner_footer

const apps_banner = ref({});

async function getAppsFooterBanner() {
    try {
        const res = await axios.get("/apps-footer-banner-data");
        apps_banner.value = res.data || {};
    } catch (error) {
        console.error("Error fetching hero text:", error);
    }
}

onMounted(() => {
    getAppsFooterBanner();
});
</script>
<template> 
    <footer class="text-gray-600 body-font min-h-auto">
        <div class="px-6 py-6 mx-auto">
            <div
                class="2xl:px-72 xl:px-40 mx-auto bg-[#2A909C] xl:pt-16 pt-8 pb-8 rounded-xl"
            >
                <div
                    class="container 2xl:px-28 px-0 flex flex-wrap sm:text-left sm:pb-6 pb-3"
                >
                    <div class="lg:w-1/6 md:w-1/2 w-full px-4">
                        <nav class="list-none font-light">
                            <ul>
                                <li class="mb-2">
                                    <a
                                        href=""
                                        class="text-black hover:text-gray-300 font-light text-sm transition duration-300"
                                        >{{ $t("nav.about_us") }}</a
                                    >
                                </li>
                                <li class="lg:mb-0 mb-2">
                                    <a
                                        href=""
                                        class="text-black hover:text-gray-300 font-light text-sm transition duration-300"
                                        >{{ $t("nav.our_services") }}</a
                                    >
                                </li>
                            </ul>
                        </nav>
                    </div>
                    <div class="lg:w-1/6 md:w-1/2 w-full px-4">
                        <nav class="list-none">
                            <ul>
                                <li class="mb-2">
                                    <Link
                                        :href="
                                            route(
                                                'policy.page',
                                                'privacy-policy'
                                            )
                                        "
                                        class="text-black hover:text-gray-300 font-light text-sm transition duration-300"
                                        >{{ $t("nav.privacy") }}</Link
                                    >
                                </li>
                                <li class="lg:mb-0 mb-2">
                                    <Link
                                        :href="route('policy.page', 'terms')"
                                        class="text-black hover:text-gray-300 font-light text-sm transition duration-300"
                                        >{{ $t("nav.terms") }}</Link
                                    >
                                </li>
                            </ul>
                        </nav>
                    </div>
                    <div class="lg:w-1/6 md:w-1/2 w-full px-4">
                        <nav class="list-none">
                            <ul>
                                <li class="mb-2">
                                    <Link
                                        :href="route('policy.page', 'refund')"
                                        class="text-black hover:text-gray-300 font-light text-sm transition duration-300"
                                        >{{ $t("nav.return_policy") }}</Link
                                    >
                                </li>
                                <!-- <li class="lg:mb-0 mb-2">
                                    <Link :href="route('policy.page', 'legal')"
                                        class="text-white hover:text-gray-300 font-light text-sm transition duration-300">{{
                                            $t('nav.leagl') }}</Link>
                                </li> -->
                            </ul>
                        </nav>
                    </div>
                    <div class="lg:w-1/6 md:w-1/2 w-full px-4">
                        <nav class="list-none">
                            <ul>
                                <li class="mb-2">
                                    <Link
                                        :href="route('contact.page')"
                                        class="text-black hover:text-gray-300 font-light text-sm transition duration-300"
                                        >{{ $t("nav.contact") }}</Link
                                    >
                                </li>
                                <li class="lg:mb-0 mb-2">
                                    <Link
                                        :href="route('career.page')"
                                        class="text-black hover:text-gray-300 font-light text-sm transition duration-300"
                                        >{{ $t("nav.career") }}</Link
                                    >
                                </li>
                            </ul>
                        </nav>
                    </div>

                    <div class="lg:w-2/6 md:w-1/2 w-full px-4 mx-auto lg:mb-0 mb-10" v-if="apps_banner?.status == true">
                        <p class="text-black sm:text-center mx-auto font-light sm:text-lg text-base mb-2">{{ apps_banner?.sub_heading }}</p>
                        <div class="flex flex-wrap sm:justify-center sm:items-center">

                            <div class="sm:w-24 w-20 sm:h-24 h-20 mr-4" v-if="apps_banner?.apk_qr_image && apps_banner?.apk_download_image">
                                <img src="/assets/images/barcode.webp" class="mb-4 border w-24 h-24 md:w-24 md:h-24 sm:w-[78px] sm:h-[78px]" alt="android app QR" loading="lazy"/>
                                <a :href="apps_banner?.apk_download_link" target="_blank" >
                                    <img :src="'/storage/' + apps_banner?.apk_download_image"   width="120" height="120" class="barcode-icon" alt="android app download"/>
                                </a>
                                
                            </div>
                            <!-- <div class="sm:w-24 w-20 sm:h-24 h-20 mr-4" v-if="apps_banner?.apk_qr_image && apps_banner?.apk_download_image">
                                <img :src="'/storage/' + apps_banner?.apk_qr_image" class="mb-4 border w-32 h-24 md:w-32 md:h-24 sm:w-[100px] sm:h-[90px]" alt="android app QR"/>
                                <a :href="apps_banner?.apk_download_link" target="_blank" >
                                    <img :src="'/storage/' + apps_banner?.apk_download_image" class="barcode-icon w-[96px] h-[31px]" alt="android app download"/>
                                </a>
                            </div> -->

                            <div class="sm:w-24 w-20 sm:h-24 h-20" v-if="apps_banner?.iso_qr_image && apps_banner?.iso_download_image">
                                <img :src="'/storage/' + apps_banner?.iso_qr_image" class="mb-4 border w-24 h-24 md:w-24 md:h-24 sm:w-[78px] sm:h-[78px]" alt="iso app QR"/>
                                <a :href="apps_banner?.iso_download_link" target="_blank">
                                    <img :src=" '/storage/' + apps_banner?.iso_download_image" class="barcode-icon w-[96px] h-[31px]" alt="iso app download"/>
                                </a>
                            </div>
                        </div>
                    </div>

                    <div class="lg:w-1/2 md:w-1/2 w-full px-4 py-y lg:mt-10 mt-0">
                        <div class="flex flex-wrap justify-start items-center mt-8">
                            <p class="text-black font-light text-sm sm:pt-4 pt-3 sm:pr-4 pr-2">
                                {{ $t("nav.follow_us") }}
                            </p>

                            <div
                                class="flex flex-wrap items-center justify-end pt-2 sm:space-x-3 space-x-2"
                            >
                                <a
                                    v-if="company?.fb"
                                    :href="company?.fb"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    aria-label="Facebook"
                                    class="text-gray-900 hover:text-[#d3d3d3] border border-gray-900 hover:border-[#d3d3d3] rounded-full sm:h-9 h-7 sm:w-9 w-7 transition duration-300 flex items-center justify-center"
                                >
                                    <i class="fa-brands fa-facebook"></i>
                                    <span class="sr-only">Facebook</span>
                                </a>

                                <a
                                    v-if="company?.in"
                                    :href="company?.in"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    aria-label="Instagram"
                                    class="text-gray-900 hover:text-[#d3d3d3] border border-gray-900 hover:border-[#d3d3d3] rounded-full sm:h-9 h-7 sm:w-9 w-7 transition duration-300 flex items-center justify-center"
                                >
                                    <i class="fa-brands fa-instagram"></i>
                                    <span class="sr-only">Instagram</span>
                                </a>

                                <a
                                    v-if="company?.yt"
                                    :href="company?.yt"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    aria-label="YouTube"
                                    class="text-gray-900 hover:text-[#d3d3d3] border border-gray-900 hover:border-[#d3d3d3] rounded-full sm:h-9 h-7 sm:w-9 w-7 transition duration-300 flex items-center justify-center"
                                >
                                    <i class="fa-brands fa-youtube"></i>
                                    <span class="sr-only">YouTube</span>
                                </a>

                                <a
                                    v-if="company?.tw"
                                    :href="company?.tw"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    aria-label="Twitter"
                                    class="text-gray-900 hover:text-[#d3d3d3] border border-gray-900 hover:border-[#d3d3d3] rounded-full sm:h-9 h-7 sm:w-9 w-7 transition duration-300 flex items-center justify-center"
                                >
                                    <i class="fa-brands fa-twitter"></i>
                                    <span class="sr-only">Twitter</span>
                                </a>

                                <a
                                    v-if="company?.li"
                                    :href="company?.li"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    aria-label="LinkedIn"
                                    class="text-gray-900 hover:text-[#d3d3d3] border border-gray-900 hover:border-[#d3d3d3] rounded-full sm:h-9 h-7 sm:w-9 w-7 transition duration-300 flex items-center justify-center"
                                >
                                    <i class="fa-brands fa-linkedin"></i>
                                    <span class="sr-only">LinkedIn</span>
                                </a>
                            </div>
                        </div>
                    </div>

                    <div
                        class="lg:w-1/2 md:w-1/2 w-full sm:px-4 px-4 lg:mt-12 mt-4 mx-auto"
                    >
                        <div
                            class="flex flex-wrap lg:justify-end justify-start items-center mt-4"
                        >
                            <p
                                class="text-black font-light lg:text-sm text-xs pt-2 lg:pr-4 pr-2"
                            >
                                {{ $t("nav.call_us") }}
                            </p>
                            <a
                                :href="`tel:` + primaryPhone[0]"
                                class="lg:mr-4 mr-2 text-gray-900 hover:text-[#d3d3d3] border border-gray-900 hover:border-[#d3d3d3] rounded-[4px] py-[6px] lg:px-4 px-1 transition duration-300 flex items-center justify-center text-sm"
                            >
                                {{ primaryPhone[0] }}
                            </a>
                            <!-- <a
                                :href="`tel:` + primaryPhone[0]"
                                class="text-gray-900 hover:text-[#d3d3d3] border border-gray-900 hover:border-[#d3d3d3] rounded-[4px] py-[6px] lg:px-4 px-1 transition duration-300 flex items-center justify-center text-sm"
                            >
                                {{ primaryPhone[1] }}
                            </a> -->
                        </div>
                    </div>
                </div>

                <div class="container 2xl:px-28 px-0">
                    <div
                        class="block overflow-hidden w-full h-full border-t pt-3"
                    >
                        <VLazyImage
                            src="/assets/images/payment.webp"
                            alt="online_payment"
                            class="w-full h-full object-cover"
                        />
                    </div>
                </div>
                <div class="mt-3">
                    <p class="text-black text-center sm:text-sm text-xs mb-1">
                        &copy; {{ helper.currentYear() }}
                        {{ company.copyright }}
                    </p>
                    <p class="text-black text-center sm:text-sm text-xs">
                        Trade license Number: TRAD/DSCC/006012/2021
                    </p>
                </div>
            </div>
        </div>
    </footer>
</template>
<style scoped></style>
